import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function TicketCardCreateNew({ onCreateClick }) {
  return (
    <div 
      onClick={onCreateClick}
      className="min-w-[200px] max-w-[200px] bg-aw-bluedark rounded-b-xl shadow-lg overflow-hidden cursor-pointer hover:scale-95 transition-all duration-300 border-2 border-dashed border-aw-green hover:border-solid"
    >
      {/* Área de imagen simulada con icono */}
      <div className="h-52 flex items-center justify-center bg-gradient-to-br from-aw-bluedark to-aw-bluedark-75 border-b-2 border-aw-green relative overflow-hidden">
        {/* Patrón de fondo */}
        <div className="absolute inset-0 opacity-10">
          <div className="grid grid-cols-4 gap-2 p-4 h-full">
            <FontAwesomeIcon icon="fa-solid fa-ticket" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-calendar" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-location-dot" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-users" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-music" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-star" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-clock" className="text-aw-green text-2xl" />
            <FontAwesomeIcon icon="fa-solid fa-heart" className="text-aw-green text-2xl" />
          </div>
        </div>
        
        {/* Icono central */}
        <div className="relative z-10 flex flex-col items-center gap-3">
          <div className="w-16 h-16 rounded-full bg-aw-green flex items-center justify-center shadow-lg">
            <FontAwesomeIcon 
              icon="fa-solid fa-plus" 
              className="text-aw-bluedark text-3xl"
            />
          </div>
          <span className="text-white font-semibold text-sm">Crear Evento</span>
        </div>
      </div>

      {/* Contenido de información */}
      <div className="px-2 py-1 flex flex-col justify-center h-[130px] text-center">
        <h3 className="font-bold text-base text-aw-green mb-2">
          Nuevo Evento
        </h3>
        <p className="text-xs text-gray-400 px-2">
          Crea un nuevo evento para tu empresa y comienza a vender tickets
        </p>
      </div>

      {/* Footer con icono */}
      <div className="flex justify-center items-center px-2 py-3 border-t border-aw-bluedark-50 bg-aw-bluedark-50">
        <div className="flex items-center gap-2 text-aw-green">
          <FontAwesomeIcon icon="fa-solid fa-circle-plus" className="text-lg" />
          <span className="text-xs font-semibold">Click para crear</span>
        </div>
      </div>
    </div>
  );
}
